import { trackingService } from "../../common/services/tracking.service";
import { getAllParamsFromURL } from "../../common/utils/url.util";

$(async () => {
  try {
    trackingService.init();
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    if (!params.size) {
      return;
    }
    const urlParams = getAllParamsFromURL();
    if (
      urlParams?.campaign_id ||
      urlParams?.campaignId ||
      urlParams?.campaign ||
      urlParams?.utmSource ||
      urlParams?.utmMedium ||
      urlParams?.utmContent ||
      urlParams?.fbclid ||
      urlParams?.gclid ||
      urlParams?.msclikid ||
      urlParams?.dclid ||
      urlParams?.fbp ||
      urlParams?.ga ||
      urlParams?.gcl_au ||
      urlParams?._ga ||
      urlParams?._gcl_au ||
      urlParams?.fbc ||
      urlParams?.medium ||
      urlParams?.mediumId ||
      urlParams?.utm_source ||
      urlParams?.utm_medium ||
      urlParams?.utm_campaign ||
      urlParams?.utm_keyword ||
      urlParams?.utm_matchtype ||
      urlParams?.ad_group_id ||
      urlParams?.ad_id ||
      urlParams?.utm_term ||
      urlParams?.utm_content ||
      urlParams?.adGroupId ||
      urlParams?.adId
    ) {
      writeCookie("campaignCookies", btoa(queryString), 7);
    }
  } catch (error) {
    trackingService.captureException(
      new Error(
        `${window.location.host} | Campaign cookie - error occured while saving the cookie, url: ${window.location.href}`
      ),
      {
        devMessage: "Campaign cookie error while saving the cookie",
        url: window.location.href,
      }
    );
    console.error("Error with campaign: ", error);
  }
});

function writeCookie(name: string, value: string, days: number): void {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function getCampaignParamsFromCookie(): Record<string, string> | null {
  const cookieName = "campaignCookies";
  const cookieValue = getCookie(cookieName);
  if (!cookieValue) {
    return null;
  }

  try {
    const decodedQueryString = atob(cookieValue);
    const queryStringWithoutLeadingQuestion = decodedQueryString.startsWith("?")
      ? decodedQueryString.slice(1)
      : decodedQueryString;

    const params = new URLSearchParams(queryStringWithoutLeadingQuestion);

    const paramsObject: Record<string, string> = {};
    params.forEach((value, key) => {
      paramsObject[key] = value;
    });

    return paramsObject;
  } catch (error) {
    console.error("Error parsing campaign cookie:", error);
    return null;
  }
}

export function getCookie(name: string): string | null {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(";");

  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i].trim();
    if (cookie.startsWith(cookieName)) {
      return cookie.substring(cookieName.length);
    }
  }

  return null;
}

export function deleteCookie(name: string): void {
  document.cookie = name + "=; Max-Age=0; path=/ ";
}

export function attachCampaignDataObject(input: Record<string, any>) {
  const campaignData = getCampaignParamsFromCookie();

  let requestData = input;
  if (campaignData) {
    requestData = {
      ...requestData,
      lastAttributionSource: snakeToCamelCase(campaignData),
    };
  }

  return requestData;
}

function snakeToCamelCase(obj: Record<string, any>): Record<string, any> {
  if (obj === null || obj === undefined) return obj;

  if (Array.isArray(obj)) {
    return obj.map((item) => snakeToCamelCase(item));
  }

  if (typeof obj !== "object") return obj;

  const camelCaseObj: Record<string, any> = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const camelKey = key.replace(/_([a-z])/g, (_, letter) =>
        letter.toUpperCase()
      );

      camelCaseObj[camelKey] = snakeToCamelCase(obj[key]);
    }
  }

  return camelCaseObj;
}
